import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import { TwoColumn, TwoRow } from "../../core/layouts";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import variables from "../../themes/base/styles/variables";

const AddProductCategoryFormLayoutStyle = {
  threeRowMainStyle: {
    display: variables.dFlex,
    gap: variables.gapSmaller,
    overflow: "unset",
    width: variables.fullWidth,
    minHeight: variables.inputContainerMinHeight,
  },
  twoRowMainStyle: {
    border: `1px solid ${variables.grey4}`,
    padding: variables.paddingSmall,
    display: variables.dFlex,
    gap: variables.gapSmaller,
    width: variables.fullWidth,
    overflow: "unset",
  },
  twoColumnMobileStyle: {
    display: variables.dFlex,
    gap: variables.gapSmaller,
  },
  inputSectionStyle: { flex: 1 },
  countrySelectSectionStyle: { width: variables.countrySelectWidth },
  removeSectionStyle: { width: variables.removeSectionWidth },
  removeSectionStyleMobile: { width: variables.removeSectionWidthMobile },
  inputSectionStyleMobile: { flex: 0.99 },
};
const AddProductCategoryFormLayout = ({
  firstSection,
  secondSection,
  thirdSection,
}) => {
  const responsive = useResponsive();
  return responsive?.isMd ? (
    <ThreeColumn
      style={AddProductCategoryFormLayoutStyle.threeRowMainStyle}
      leftSectionStyle={AddProductCategoryFormLayoutStyle.inputSectionStyle}
      leftSection={firstSection}
      middleSectionStyle={
        AddProductCategoryFormLayoutStyle.countrySelectSectionStyle
      }
      middleSection={secondSection}
      rightSectionStyle={AddProductCategoryFormLayoutStyle.removeSectionStyle}
      rightSection={thirdSection}
    />
  ) : (
    <TwoRow
      style={AddProductCategoryFormLayoutStyle.twoRowMainStyle}
      topSection={
        <TwoColumn
          style={AddProductCategoryFormLayoutStyle.twoColumnMobileStyle}
          leftSection={firstSection}
          leftSectionStyle={
            AddProductCategoryFormLayoutStyle.inputSectionStyleMobile
          }
          rightSectionStyle={
            AddProductCategoryFormLayoutStyle.removeSectionStyleMobile
          }
          rightSection={thirdSection}
        />
      }
      bottomSection={secondSection}
    />
  );
};

export default AddProductCategoryFormLayout;
